import React from 'react';
import { defaultTemplate } from 'core/hoc';

function ErrorWarningInfoModalTemplate({
	ErrorWarningInfoModalViewStore: { errors, warnings, info, title, subtitleComponent },
	t,
}) {
	return (
		<section>
			{/* Header */}
			<div className="ReactModal__header">
				<h2 className="spc--bottom--sml">
					<RenderHeaderIcon errors={errors} warnings={warnings} />
					{title}
				</h2>
				{subtitleComponent && <div className="spc--bottom--sml">{subtitleComponent}</div>}
			</div>

			{/* Body */}
			<div className="ReactModal__body">
				{errors && errors.length > 0 && (
					<div>
						<h3>Errors</h3>
						<LogSection items={errors} type="error" />
					</div>
				)}

				{warnings && warnings.length > 0 && (
					<div>
						<h3>Warnings</h3>
						<LogSection items={warnings} type="warning" />
					</div>
				)}

				{info && info.length > 0 && (
					<div>
						<h3>Info</h3>
						<LogSection items={info} type="info" />
					</div>
				)}
			</div>

			<div className="ReactModal__footer"></div>
		</section>
	);
}

function RenderHeaderIcon({ errors, warnings }) {
	if (errors && errors.length > 0) {
		return <i className="type--color--error fa fa-times-circle spc--right--sml" />;
	} else if (warnings && warnings.length > 0) {
		return <i className="type--color--warning-light fa fa-exclamation-circle spc--right--sml" />;
	} else {
		return <i className="type--color--success fa fa-check-circle spc--right--sml" />;
	}
}

function LogSection({ items, type }) {
	return (
		<div className="errorwarninginfo errorwarninginfo__list" style={{ padding: '1rem 0' }}>
			<div className="errorwarninginfo__entry">
				<ul className="errorwarninginfo__errors errorwarninginfo__list_no_bulletpoints">
					{items.map(function(entry, idx) {
						return (
							<li
								key={idx}
								className={
									type === 'error'
										? 'errorwarninginfo__error errorwarninginfo__list_element'
										: 'errorwarninginfo__warning errorwarninginfo__list_element'
								}
							>
								{type === 'error' ? (
									<i className="type--color--error fa fa-times-circle spc--right--nano" />
								) : type === 'warning' ? (
									<i className="type--color--warning-light fa fa-exclamation-circle spc--right--nano" />
								) : (
									<i className="type--color--success fa fa-check-circle spc--right--nano" />
								)}

								{entry}
							</li>
						);
					})}
				</ul>
			</div>
		</div>
	);
}

export default defaultTemplate(ErrorWarningInfoModalTemplate);
